import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Slide from "@material-ui/core/Slide";
import { Grid, FormControl, MenuItem, Typography } from "@material-ui/core";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  ValidatorForm,
  SelectValidator,
  TextValidator,
} from "react-material-ui-form-validator";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const AlertFinalizadoStepper = (props) => {
  const [listaCombo, setListaCombo] = useState([]);
  const [displayAlertMaxCaracteres, setDisplayAlertMaxCaracteres] =
    useState(false);

  const handleChange = (e) => {
    if (props.esFactura && e.target.value.length >= 500) {
      setDisplayAlertMaxCaracteres(true);
    } else {
      setDisplayAlertMaxCaracteres(false);
      props.setObservacion(e.target.value);
    }
  };

  const handleDateChange = (date) => {
    props.setFechaVigencia(date);
  };

  useEffect(() => {
    if (props.showComboDialog && props.itemsCombo.length > 0) {
      const generarValoresCombo = () => {
        if (props.idCombo === "idMotivoBajaTurno") {
          let listaFromProps = props.itemsCombo.map((item) => {
            return {
              value: item.idMbt,
              display: item.descripcion,
            };
          });
          setListaCombo(listaFromProps);
        }
      };
      generarValoresCombo();
    }
  }, [props.showComboDialog, props.itemsCombo, props.idCombo]);

  return (
    <Grid item>
      <Dialog
        open={props.open}
        TransitionComponent={Transition}
        keepMounted
        // onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <Grid item container justify="center">
          <DialogTitle id="alert-dialog-slide-title">
            {props.pregunta}
          </DialogTitle>
          <DialogContent style={{ inlineSize: "-webkit-fill-available" }}>
            <DialogContentText id="alert-dialog-slide-description">
              {props.dialogText}
            </DialogContentText>
          </DialogContent>
        </Grid>
        {props.showTextarea &&
          (props.textBoxWithContent ? (
            <Grid>
              <TextareaAutosize
                style={{
                  marginLeft: 24,
                  width: 552,
                  fontFamily: "Roboto",
                  fontSize: 15,
                }}
                aria-label="empty textarea"
                placeholder={props.textBoxPlaceholder ? props.textBoxPlaceholder : "..."}
                rowsMin={3}
                rowsMax={5}
                value={props.value}
                onChange={handleChange}
              />
              {displayAlertMaxCaracteres && (
                <Typography
                  style={{
                    color: "red",
                    paddingLeft: "1.6rem",
                    fontStyle: "italic",
                  }}
                >
                  No debe exceder los 500 caracteres
                </Typography>
              )}
            </Grid>
          ) : (
            <Grid>
              <TextareaAutosize
                style={{
                  marginLeft: 24,
                  width: 552,
                  fontFamily: "Roboto",
                  fontSize: 15,
                }}
                aria-label="empty textarea"
                placeholder={props.textBoxPlaceholder ? props.textBoxPlaceholder : "..."}
                rowsMin={3}
                rowsMax={5}
                value={props.value}
                onChange={handleChange}
              />
              {displayAlertMaxCaracteres && (
                <Typography
                  style={{
                    color: "red",
                    paddingLeft: "1.6rem",
                    fontStyle: "italic",
                  }}
                >
                  No debe exceder los 500 caracteres
                </Typography>
              )}
            </Grid>
          ))}
        {props.showDateDialog && (
          <Grid item container justify="center">
            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
              <KeyboardDatePicker
                margin="normal"
                id="date-picker-dialog"
                label="Fecha vigencia"
                format="dd/MM/yyyy"
                value={props.fechaVigencia}
                onChange={handleDateChange}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>
        )}
        {props.showTextBox && (
          <ValidatorForm onSubmit={props.handleSend}>
            <Grid
              container
              justify="center"
              style={{ marginTop: -25, marginBottom: 25 }}
            >
              <TextValidator
                autoFocus
                margin="normal"
                value={props.textBoxValue}
                label={props.textBoxLabel}
                onChange={(e) => props.setTextBoxValue(e.target.value)}
                validators={["required"]}
                errorMessages={["Este campo es obligatorio"]}
              />
            </Grid>
          </ValidatorForm>
        )}
        {props.showComboDialog ? (
          <ValidatorForm onSubmit={props.handleSend}>
            <Grid
              container
              justify="center"
              style={{ marginTop: -25, marginBottom: 25 }}
            >
              <Grid item xs={6}>
                <FormControl margin="normal" fullWidth={true}>
                  <SelectValidator
                    onChange={(e) => {
                      props.manejadorInputChange(e);
                    }}
                    label={props.labelCombo}
                    name={props.idCombo}
                    value={props.valor}
                    fullWidth={true}
                    validators={["required"]}
                    errorMessages={["seleccione una opcion"]}
                  >
                    <MenuItem value="">
                      <em>Seleccione</em>
                    </MenuItem>
                    {listaCombo.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.display}
                      </MenuItem>
                    ))}
                  </SelectValidator>
                </FormControl>
              </Grid>
            </Grid>
            <DialogActions>
              <Grid item container justify="center">
                <Button onClick={props.handleClose} color="primary">
                  {props.buttonCancel}
                </Button>
                <Button
                  type="submit"
                  style={{ marginLeft: 150 }}
                  color="primary"
                >
                  {props.buttonSubmit}
                </Button>
              </Grid>
            </DialogActions>
          </ValidatorForm>
        ) : (
          <DialogActions>
            <Grid item container justify="center">
              {props.buttonCancel&&
                <Button onClick={props.handleClose} color="primary">
                  {props.buttonCancel}
                </Button>
              }
              <Button
                onClick={props.handleSend}
                style={{ marginLeft: 150 }}
                color="primary"
              >
                {props.buttonSubmit}
              </Button>
            </Grid>
          </DialogActions>
        )}
      </Dialog>
    </Grid>
  );
};
